const MODAL_TYPES = {
  ITINERARY: "ITINERARY",
  IMAGES: "IMAGES",
  STATEROOMS: "STATEROOMS",
};

const MODAL = { MODAL_TYPES };

export default MODAL;
